import { Form, Formik } from "formik";
import React from "react";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import { REGISTER_USER } from "../../../api/apiAdmin";
import InputField from "../../atoms/InputField";
import Button from "../../atoms/Button";

const ModalCreateLeader = ({ onClose, refetch}) => {
    const validate = (values) => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!values.name) { errors.name = "El nombre es requerido"; }
        if (!values.email) { errors.email = "El email es requerido"; } 
            else if (!emailRegex.test(values.email)) { errors.email = "El email no es válido"; }
        if (!values.password) { errors.password = "La contraseña es requerida"; }
        return errors;
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const upperCaseValues = {
                ...values,
                name: values.name.toUpperCase(),
            };
            await REGISTER_USER(upperCaseValues);
            toast.success("Registro exitoso");
            refetch();
            onClose();
        } catch(error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = { name: "", email: "", password: "", role: "Admin", cellphone:"", isSuperAdmin: false }

    return(
        <div>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validate={validate}
            >
                {({ isSubmitting }) => (
                    <Form className="w-full flex flex-col items-center justify-center text-center space-y-4">
                        <InputField name="name" label="Nombre completo" placeholder="Nombre completo" capitalize />
                        <InputField name="cellphone" label="Teléfono" placeholder="Número de teléfono" type="number" capitalize />
                        <InputField name="email" label="Correo electrónico" placeholder="CORREO ELECTRÓNICO" />
                        <InputField name="password" label="Contraseña" type="password" placeholder="CONTRASEÑA" />
                        <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Registrar"} type="submit" disabled={isSubmitting} bgColor="blue" />
                    </Form>
                )}
            </Formik>
        </div>
    )
};

export default ModalCreateLeader;